export default "__VITE_ASSET__CDUBNHFc__"